import { useEffect } from 'react';

/**
 * Custom hook to initialize Lenis smooth scroll.
 * Defer initialization until the first user interaction to maximize performance (FCP/SI).
 */
export const useLenis = () => {
  useEffect(() => {
    let lenis: import('lenis').default | undefined;
    let rafId: number;
    let cleaned = false;

    import('lenis').then(({ default: Lenis }) => {
      if (cleaned) return;
      
      lenis = new Lenis({
        duration: 1.0,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        touchMultiplier: 1.5,
      });

      (window as any).__lenis = lenis;

      function raf(time: number) {
        if (lenis) {
          lenis.raf(time);
          rafId = requestAnimationFrame(raf);
        }
      }
      rafId = requestAnimationFrame(raf);
    });

    return () => {
      cleaned = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis) {
        if ((window as any).__lenis === lenis) {
           delete (window as any).__lenis;
        }
        lenis.destroy();
      }
    };
  }, []);
};
